
import { z } from 'zod';
import { ChatResponseType } from '../enums/chat';
import type { Chart } from './chat.chart';

// Zod schemas
export const QuantItemSchema = z.object({
  quantId: z.number(),
  quantItemId: z.number(),
  title: z.string(),
});
export type QuantItem = z.infer<typeof QuantItemSchema>;

// ChatQueryResponseQuotes
export const QuoteItemSchema = z.object({
  starredQuoteId: z.number().nullable(),
  transcriptId: z.number(),
  startTs: z.number(),
  endTs: z.number(),
  citationKey: z.string().nullable(),
  value: z.string(),
});
export type QuoteItem = z.infer<typeof QuoteItemSchema>;


// ChatQueryResponseQuotes
export const ChatQueryResponseQuotesDataSchema = z.object({
  quotes: z.array(z.object({
    starredQuoteId: z.number().nullable(),
    transcriptId: z.number(),
    startTs: z.number(),
    endTs: z.number(),
    citationKey: z.string().nullable(),
    value: z.string(),
  })),
  source: z.enum(['saved-quotes', 'search']),
  topic: z.string(),
});
export const ChatQueryResponseQuotesSchema = z.object({
  type: z.literal(ChatResponseType.BIFindQuotes),
  data: ChatQueryResponseQuotesDataSchema,
  value: z.string(),
});
export type ChatQueryResponseQuotes = z.infer<typeof ChatQueryResponseQuotesSchema>;


// ChatQueryResponseQuantData
export const ChatQueryResponseQuantDataSchema = z.object({
  quants: z.array(QuantItemSchema),
  query: z.string(),
  projectId: z.number(),
  showLowConfidenceWarning: z.boolean().nullable(),
});
export type ChatQueryResponseQuantData = z.infer<typeof ChatQueryResponseQuantDataSchema>;
export const ChatQueryResponseQuantSchema = z.object({
  type: z.literal(ChatResponseType.BIFindQuantAnalyses),
  data: ChatQueryResponseQuantDataSchema,
  value: z.string(),
});
export type ChatQueryResponseQuant = z.infer<typeof ChatQueryResponseQuantSchema>;


// ChatQueryResponseQuantChartData
export const QuantDataContextSchema = z.object({
  records: z.array(z.array(z.string().nullable())),
  rowNames: z.array(z.array(z.string().nullable())),
  columnNames: z.array(z.array(z.string().nullable())),
});

export const ChatQueryResponseQuantChartDataSchema = z.object({
  chart: z.custom<Chart>(), // You may want to define a schema for Chart if possible
  query: z.string(),
  quantId: z.number(),
  quantItemId: z.number(),
  projectId: z.number(),
  title: z.string(),
  table: QuantDataContextSchema,
  footer: z.array(z.string()),
  showWarning: z.boolean(),
  quants: z.array(QuantItemSchema).nullable(),
});
export const ChatQueryResponseQuantChartSchema = z.object({
  type: z.literal(ChatResponseType.BIChartQuantAnalyses),
  data: ChatQueryResponseQuantChartDataSchema,
  value: z.string(),
});

export type ChatQueryResponseQuantChart = z.infer<typeof ChatQueryResponseQuantChartSchema>;
